<template>
    <div class="app-container" v-loading="loading">
        <el-row
            style="margin-top: 20px; margin-bottom: 10px"
            :gutter="10"
            class="mb8"
        >
            <el-col :span="3">
                <el-input
                    clearable
                    size="mini"
                    v-model="param.keywords"
                    placeholder="请输入关键字"
                ></el-input>
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="warning"
                    icon="el-icon-search"
                    size="mini"
                    @click="GetSearchJounals"
                    >搜索</el-button
                >
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="handleAdd"
                    >新增</el-button
                >
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="success"
                    icon="el-icon-edit"
                    size="mini"
                    :disabled="single"
                    @click="handleUpdate"
                    >修改</el-button
                >
            </el-col>
            <el-col :span="1.5">
                <el-button
                    type="danger"
                    icon="el-icon-delete"
                    size="mini"
                    :disabled="multiple"
                    @click="handleDelete"
                    >删除</el-button
                >
            </el-col>
        </el-row>

        <el-table :data="journalData" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="30" />
            <el-table-column prop="detail.name" width="140" label="期刊图片">
                <template slot-scope="scope">
                    <img
                        :src="scope.row.detail.image"
                        style="width: 80px; height: 100px"
                        alt=""
                    />
                </template>
            </el-table-column>
            <el-table-column prop="detail.name" label="期刊名称">
                <!-- <template slot-scope="scope">
          <div class="cellstyle" v-html="fnAddBrs(scope.detail.name)"></div>
        </template> -->
            </el-table-column>
            <el-table-column
                prop="detail.issn"
                width="140"
                label="期刊刊号"
            ></el-table-column>
            <!-- <el-table-column prop="detail.competent_organization" label="主管单位">
        <template slot-scope="scope">
          {{ scope.row.detail.competent_organization || "" }}
        </template>
      </el-table-column> -->
            <el-table-column
                prop="detail.publisher_name"
                width="140"
                label="主办/出版(单位)"
            >
                <template slot-scope="scope">
                    {{
                        scope.row.detail.short_name
                            ? scope.row.detail.publisher_name
                            : scope.row.detail.organizer_name
                    }}
                </template>
            </el-table-column>
            <el-table-column
                prop="detail.chief_editor"
                width="140"
                label="主编"
            >
            </el-table-column>
            <el-table-column
                prop="detail.subject_small_category"
                label="学科类别"
            >
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.category.subject_field">{{
                        translateSubjectField(scope.row.category.subject_field)
                    }}</el-tag
                    ><br />
                    <el-tag
                        v-if="scope.row.detail.subject_small_category"
                        type="success"
                        >{{ scope.row.detail.subject_small_category }}</el-tag
                    >
                </template>
            </el-table-column>
            <el-table-column prop="category_index" label="收录索引">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.category.category_index[0]">{{
                        scope.row.category.category_index[0]
                            ? translateCategoryIndex(
                                  scope.row.category.category_index[0]
                              )
                            : ""
                    }}</el-tag>
                    <el-tag
                        style="margin-left: 10px"
                        v-if="scope.row.category.category_index[1]"
                        >{{
                            scope.row.category.category_index[1]
                                ? translateCategoryIndex(
                                      scope.row.category.category_index[1]
                                  )
                                : ""
                        }}</el-tag
                    >
                    <el-tag
                        style="margin-left: 10px"
                        v-if="scope.row.category.category_index[2]"
                        >{{
                            scope.row.category.category_index[2]
                                ? translateCategoryIndex(
                                      scope.row.category.category_index[2]
                                  )
                                : ""
                        }}</el-tag
                    >
                    <el-tag
                        style="margin-left: 10px"
                        v-if="scope.row.category.category_index[3]"
                        >{{
                            scope.row.category.category_index[3]
                                ? translateCategoryIndex(
                                      scope.row.category.category_index[3]
                                  )
                                : ""
                        }}</el-tag
                    >
                    <el-tag
                        style="margin-left: 10px"
                        v-if="scope.row.category.category_index[4]"
                        >{{
                            scope.row.category.category_index[4]
                                ? translateCategoryIndex(
                                      scope.row.category.category_index[4]
                                  )
                                : ""
                        }}</el-tag
                    >
                </template>
            </el-table-column>
            <el-table-column prop="detail.introduction" label="期刊介绍">
                <template slot-scope="scope">
                    <div class="cellstyle">
                        {{ scope.row.detail.introduction }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="160"
                class-name="small-padding fixed-width"
            >
                <template slot-scope="scope">
                    <!-- <i
            class="el-icon-view"
            style="color: rgb(24, 144, 255); cursor: pointer;"
            @click="handledetails(scope.row)"
            >详情</i
          > -->
                    <i
                        class="el-icon-edit"
                        style="margin-left: 10px; color: rgb(24, 144, 255); cursor: pointer"
                        @click="handleUpdate(scope.row)"
                        >修改</i
                    >
                    <i
                        style="margin-left: 10px; color: rgb(24, 144, 255); cursor: pointer"
                        class="el-icon-delete"
                        @click="handleDelete(scope.row)"
                        >删除</i
                    >
                </template>
            </el-table-column>
        </el-table>

        <pagination
            :total="total"
            :page.sync="param.pageNum"
            :limit.sync="param.pageSize"
            @pagination="GetSearchJounal"
        />
        <!-- 弹窗新增修改 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            width="70%"
        >
            <el-steps :active="active" align-center finish-status="success">
                <el-step title="期刊信息"></el-step>
                <el-step title="期刊类别"></el-step>
                <el-step title="期刊等级"></el-step>
                <el-step title="影响因子"></el-step>
            </el-steps>
            <el-form ref="form" :model="form" label-width="120px">
                <el-row style="margin-top: 30px" v-if="active == 0">
                    <el-col :span="12">
                        <el-form-item label="期刊名称">
                            <el-input
                                placeholder="请输入期刊名称"
                                v-model="form.detail.name"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="期刊刊号">
                            <el-input
                                placeholder="请输入期刊刊号"
                                v-model="form.detail.issn"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="期刊简称">
                            <el-input
                                placeholder="请输入期刊简称"
                                v-model="form.detail.short_name"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="主管单位">
                            <el-input
                                placeholder="请输入主管单位"
                                v-model="form.detail.competent_organization"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="主办单位">
                            <el-input
                                placeholder="请输入主办单位"
                                v-model="form.detail.organizer_name"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="出版单位">
                            <el-input
                                placeholder="请输入出版单位"
                                v-model="form.detail.publisher_name"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="主编">
                            <el-input
                                placeholder="请输入主编"
                                v-model="form.detail.chief_editor"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-form-item label="期刊图片">
              <el-input placeholder="请输入期刊图片" v-model="form.image"></el-input>
            </el-form-item> -->
                        <el-form-item label="期刊图片" style="text-align: left">
                            <img
                                v-if="!(flie.length > 0) && form.detail.image"
                                style="width: 100px; height: 148px"
                                :src="form.detail.image"
                                alt=""
                            />
                            <el-upload
                                style="display: inline; text-align: left"
                                action=""
                                list-type="picture-card"
                                :file-list="flie"
                                :on-remove="UpdatahandleRemove"
                                :on-change="UpdataMatchhandleChange"
                                :auto-upload="false"
                            >
                                <i class="el-icon-edit"></i>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="官网链接">
                            <el-input
                                placeholder="请输入官网链接"
                                v-model="form.detail.uccn"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="期刊简介">
                            <el-input
                                type="textarea"
                                :rows="10"
                                placeholder="请输入期刊简介"
                                v-model="form.detail.introduction"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 30px" v-if="active == 1">
                    <el-col :span="12">
                        <el-form-item label="期刊索引">
                            <el-select
                                style="width: 100%"
                                multiple
                                v-model="form.category.category_index"
                                placeholder="请选择期刊索引"
                            >
                                <el-option
                                    v-for="item in categoryData[0]
                                        .category_index"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="期刊等级">
                            <el-select
                                style="width: 100%"
                                multiple
                                v-model="form.category.grade"
                                placeholder="请选择期刊等级（有哪些等级）"
                            >
                                <el-option
                                    v-for="item in categoryData[1].grade"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学科语言">
                            <el-select
                                style="width: 100%"
                                v-model="form.category.journal_language"
                                placeholder="请选择学科语言"
                            >
                                <el-option
                                    v-for="item in categoryData[2]
                                        .journal_language"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="期刊分区">
                            <el-select
                                style="width: 100%"
                                v-model="form.category.journal_partition"
                                placeholder="请选择期刊分区"
                            >
                                <el-option
                                    v-for="item in categoryData[3]
                                        .journal_partition"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学科领域一级">
                            <el-select
                                style="width: 100%"
                                v-model="form.category.subject_field"
                                placeholder="请选择学科领域一级"
                            >
                                <el-option
                                    v-for="item in categoryData[4]
                                        .subject_field"
                                    :key="item.id"
                                    :label="item.value"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学科领域二级">
                            <el-input
                                placeholder="请输入学科领域二级"
                                v-model="form.detail.subject_small_category"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 30px" v-if="active == 2">
                    <el-col :span="12">
                        <el-form-item label="综合评级">
                            <el-input
                                placeholder="请输入综合评级"
                                v-model="form.organization_grade.rate"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="ABDC等级">
                            <el-input
                                placeholder="请输入ABDC等级"
                                v-model="form.organization_grade.ABDC_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="AJG等级">
                            <el-input
                                placeholder="请输入AJG等级"
                                v-model="form.organization_grade.AJG_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="央财等级">
                            <el-input
                                placeholder="请输入央财等级"
                                v-model="form.organization_grade.CUFE_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="FMS等级">
                            <el-input
                                placeholder="请输入FMS等级"
                                v-model="form.organization_grade.FMS_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="外经贸等级">
                            <el-input
                                placeholder="请输入外经贸等级"
                                v-model="form.organization_grade.FTE_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="复旦等级">
                            <el-input
                                placeholder="请输入复旦等级"
                                v-model="form.organization_grade.FuDan_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="光华等级">
                            <el-input
                                placeholder="请输入光华等级"
                                v-model="form.organization_grade.GuangHua_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="JCR等级">
                            <el-input
                                placeholder="请输入JCR等级"
                                v-model="form.organization_grade.JCR_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="上财等级">
                            <el-input
                                placeholder="请输入上财等级"
                                v-model="form.organization_grade.SHUFE_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="西财等级">
                            <el-input
                                placeholder="请输入西财等级"
                                v-model="form.organization_grade.SUFE_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="厦大等级">
                            <el-input
                                placeholder="请输入厦大等级"
                                v-model="form.organization_grade.XiaDa_grade"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row
                    style="margin-top: 30px; margin-left: 74px"
                    :gutter="10"
                    class="mb8"
                    v-if="active == 3"
                >
                    <el-col :span="2">
                        <el-button type="primary" @click="handleAddyear_factor"
                            >增加影响因子</el-button
                        >
                    </el-col>
                </el-row>
                <el-row v-if="active == 3">
                    <el-col :span="12">
                        <el-form-item label="最新影响因子">
                            <el-input
                                placeholder="请输入最新影响因子"
                                v-model="form.detail.foi"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 10px" v-if="active == 3">
                    <template v-for="(item, index) in form.year_factor">
                        <el-col :span="12" :key="index + 'year'">
                            <el-form-item label="年份">
                                <el-date-picker
                                    style="width: 100%"
                                    v-model="form.year_factor[index].year"
                                    type="year"
                                    value-format="yyyy"
                                    placeholder="选择年"
                                    :picker-options="pickerOptions"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" :key="index + 'factor'">
                            <el-form-item label="影响因子">
                                <el-input
                                    placeholder="请输入厦大等级"
                                    v-model="form.year_factor[index].factor"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </template>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" v-if="active > 0" @click="upper"
                    >上一步</el-button
                >
                <el-button type="primary" v-if="active != 3" @click="next">
                    下一步
                </el-button>
                <el-button type="success" v-if="active == 3" @click="confirm">
                    完成提交
                </el-button>
                <!-- <el-button type="primary" @click="confirm">确 定</el-button> -->
                <el-button @click="cancel">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    search_category,
    search_journal,
    delete_journal,
    journal_particulars,
    add_journal_image,
    add_journal,
    update_journal
} from "@/api/jounal.js";
export default {
    name: "PeriodicalManagement",
    data() {
        return {
            loading: false,
            categoryData: [], //分类列表
            journalData: [], //期刊分类
            param: {
                keywords: "",
                pageNum: 1,
                pageSize: 10
            },
            total: 0,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            flie: [], //图片地址
            form: {
                // 期刊分类
                category: {
                    category_index: [], //期刊索引
                    grade: [], //期刊等级
                    journal_language: "", //期刊语言
                    journal_partition: "", //分区
                    subject_field: "" //一级学科
                },
                // 期刊信息
                detail: {
                    competent_organization: "", //主管单位
                    foi: "", //最新影响因子
                    image: "", //期刊图片地址
                    introduction: "", //期刊简介
                    issn: "", //期刊刊号
                    name: "", //期刊名称
                    organizer_name: "", //主办单位
                    publisher_name: "", //出版单位
                    short_name: "", //期刊简称
                    subject_small_category: "", //学科类别--二级学科
                    uccn: "", //官网链接
                    chief_editor: "" //主编
                },
                // 期刊等级
                organization_grade: {
                    ABDC_grade: "", //ABDC等级
                    AJG_grade: "", //AJG等级
                    CUFE_grade: "", //央财等级
                    FMS_grade: "", //FMS等级
                    FTE_grade: "", //外经贸等级
                    FuDan_grade: "", //复旦等级
                    GuangHua_grade: "", //光华等级
                    JCR_grade: "", //JCR等级
                    SHUFE_grade: "", //上财等级
                    SUFE_grade: "", //西财等级
                    XiaDa_grade: "", //厦大等级
                    rate: "" //综合评级(总结得出)
                },
                // 影响因子
                year_factor: []
            },
            active: 0,
            nextTitle: "下一步",
            dialogTitle: "新增期刊",
            dialogVisible: false,
            pickerOptions: {
                //disabled为函数，返回值为布尔值，
                disabledDate: time => {
                    let minYear = new Date().getFullYear() - 30;
                    return (
                        time > Date.now() ||
                        time.getTime() < new Date(JSON.stringify(minYear))
                    );
                }
            }
        };
    },
    created() {
        this.GetSearchCategory();
        this.GetSearchJounal();
    },
    methods: {
        // 获取学科分类数据
        GetSearchCategory() {
            search_category().then(res => {
                this.categoryData = res.info_list;
            });
        },
        // 获取期刊列表数据
        GetSearchJounal() {
            search_journal(this.param).then(res => {
                this.journalData = res.data.list;
                this.total = res.data.total;
            });
        },
        // 点击搜索获取期刊列表数据
        GetSearchJounals() {
            this.param.pageNum = 1;
            this.param.pageSize = 10;
            search_journal(this.param).then(res => {
                this.journalData = res.data.list;
                this.total = res.data.total;
            });
        },
        // 移除图片
        UpdatahandleRemove(flie, flieList) {
            this.flie = fileList;
        },
        // 新增影响因子表单数据
        handleAddyear_factor() {
            this.form.year_factor.push({
                factor: "",
                year: ""
            });
        },
        // 选择图片（只能选择一张）
        UpdataMatchhandleChange(flie, flieList) {
            if (flieList.length > 1) {
                this.flie = [flieList[1]];
            } else {
                this.flie = flieList;
            }
        },
        upper() {
            if (this.active-- < 0) {
                this.active = 0;
            }
        },
        // 下一步
        next() {
            if (this.active >= 4) {
                return;
            }
            this.active++;
        },
        // 取消
        cancel() {
            this.eliminate();
            this.GetSearchJounal();
            this.flie = [];
            this.dialogTitle = "新增期刊";
            this.dialogVisible = false;
        },
        // 清除
        eliminate() {
            this.form = {
                // 期刊分类
                category: {
                    category_index: [], //期刊索引
                    grade: [], //期刊等级
                    journal_language: "", //期刊语言
                    journal_partition: "", //分区
                    subject_field: "" //一级学科
                },
                // 期刊信息
                detail: {
                    competent_organization: "", //主管单位
                    foi: "", //最新影响因子
                    image: "", //期刊图片地址
                    introduction: "", //期刊简介
                    issn: "", //期刊刊号
                    name: "", //期刊名称
                    organizer_name: "", //主办单位
                    publisher_name: "", //出版单位
                    short_name: "", //期刊简称
                    subject_small_category: "", //学科类别--二级学科
                    uccn: "", //官网链接
                    chief_editor: "" //主编
                },
                // 期刊等级
                organization_grade: {
                    ABDC_grade: "", //ABDC等级
                    AJG_grade: "", //AJG等级
                    CUFE_grade: "", //央财等级
                    FMS_grade: "", //FMS等级
                    FTE_grade: "", //外经贸等级
                    FuDan_grade: "", //复旦等级
                    GuangHua_grade: "", //光华等级
                    JCR_grade: "", //JCR等级
                    SHUFE_grade: "", //上财等级
                    SUFE_grade: "", //西财等级
                    XiaDa_grade: "", //厦大等级
                    rate: "" //综合评级(总结得出)
                },
                // 影响因子
                year_factor: []
            };
        },
        // 确认
        confirm() {
            // 如果id存在，代表修改否则为新增
            if (this.form.detail.id) {
                // 如果文件列表数组长度大于0，为用户选择修改图片功能
                if (this.flie.length > 0) {
                    var data = new FormData();
                    data.append("file", this.flie[0].raw);
                    data.append("id", this.form.detail.id);
                    add_journal_image(data).then(res => {
                        if (res.code == 200) {
                            let CopyForm = JSON.parse(
                                JSON.stringify(this.form)
                            );
                            CopyForm.detail.image = res.img_url;
                            update_journal(CopyForm).then(success => {
                                if (success.code == 200) {
                                    this.$message({
                                        message: success.msg,
                                        type: "success"
                                    });
                                    this.cancel();
                                }
                            });
                        }
                    });
                } else {
                    update_journal(this.form).then(success => {
                        if (success.code == 200) {
                            this.$message({
                                message: success.msg,
                                type: "success"
                            });
                            this.cancel();
                        }
                    });
                }
            } else {
                // 如果文件列表数组长度大于0，为用户选择修改图片功能
                if (this.flie.length > 0) {
                    var data = new FormData();
                    data.append("file", this.flie[0].raw);
                    data.append("id", "");
                    add_journal_image(data)
                        .then(res => {
                            if (res.code == 200) {
                                let CopyForm = JSON.parse(
                                    JSON.stringify(this.form)
                                );
                                CopyForm.detail.image = res.img_url;
                                add_journal(CopyForm).then(success => {
                                    if (success.code == 200) {
                                        this.$message({
                                            message: success.msg,
                                            type: "success"
                                        });
                                        this.cancel();
                                    }
                                });
                            }
                        })
                        .catch(() => {
                            this.flie = [];
                        });
                } else {
                    add_journal(this.form).then(success => {
                        if (success.code == 200) {
                            this.$message({
                                message: success.msg,
                                type: "success"
                            });
                            this.cancel();
                        }
                    });
                }
            }
        },
        //   翻译学科语言
        translateJournalLanguage(item) {
            let language;
            this.categoryData[2].journal_language.forEach(element => {
                if (element.if == item) {
                    language = element.value;
                }
            });
            return language;
        },
        // 翻译一级学科
        translateSubjectField(item) {
            let subject;

            this.categoryData[4].subject_field.forEach(element => {
                if (element.id == item) {
                    subject = element.value;
                }
            });
            return subject;
        },
        // 翻译分区
        translateJournalPartition(item) {
            let partition;
            this.categoryData[3].journal_partition.forEach(element => {
                if (element.id == item) {
                    partition = element.value;
                }
            });
            return partition;
        },
        // 翻译索引
        translateCategoryIndex(item) {
            let category;
            this.categoryData[0].category_index.forEach(element => {
                if (element.id == item) {
                    category = element.value;
                }
            });
            return category;
        },
        // 翻译等级
        translateGrade(item) {
            let grade;
            this.categoryData[1].grade.forEach(element => {
                if (element.id == item) {
                    grade = element.value;
                }
            });
            return grade;
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.detail.id);
            this.single = selection.length != 1;
            this.multiple = !selection.length;
        },
        handleAdd() {
            this.active = 0;
            this.eliminate();
            this.dialogTitle = "新增期刊";
            this.dialogVisible = true;
            this.flie = [];
        },
        handledetails(item) {
            journal_particulars({ journal_id: item.detail.id }).then(res => {
                this.form = res;
            });
        },
        handleUpdate(item) {
            let id = item.detail.id || this.ids[0];
            journal_particulars({ journal_id: id }).then(res => {
                this.form = res;
                this.flie = [];
                this.active = 0;
                this.dialogTitle = "修改期刊";
                this.dialogVisible = true;
            });
        },
        handleDelete(item) {
            var id;
            if (item.detail.id) {
                id = [item.detail.id];
            } else {
                id = this.ids;
            }
            this.$confirm("此操作将永久删除该期刊, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.loading = true;
                    delete_journal({ journal_ids: id })
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: "success"
                                });
                                this.GetSearchJounal();
                                this.loading = false;
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        }
    }
};
</script>

<style>
.cellstyle {
    height: 134px;
    height: 95px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
}
.el-table .el-table__cell {
    padding: 6px 0px;
}
</style>
